module.exports = __webpack_public_path__ + "img/emo_37.428e41e4.gif";